import { Breadcrumb } from 'react-bootstrap';
import React from 'react';
import { connect } from 'react-redux';
import { fetchClientAncestors } from 'actions/ClientsActions';
import { injectIntl } from 'react-intl';

class Breadcrumbs extends React.Component {
  componentDidMount() {
    const { parent, getAncestors } = this.props;

    if (parent) {
      getAncestors(parent);
    }
  }

  componentDidUpdate(prevProps) {
    const { parent, getAncestors } = this.props;

    if (parent && parent !== prevProps.parent) {
      getAncestors(parent);
    }
  }

  render() {
    const { intl, ancestors, parent } = this.props;

    const urlPrefix = `/${intl.locale}/` || '/de/';

    return (
      <>
        <Breadcrumb>
          {ancestors.map(client =>
            parent === client.id ? (
              <Breadcrumb.Item active>{client.company}</Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item href={`${urlPrefix}account/clients?filter[parent]=${client.id}`} key={client.id}>
                {client.company}
              </Breadcrumb.Item>
            )
          )}
        </Breadcrumb>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ancestors: state.clientBreadcrumbs.ancestors,
  };
};

const mapDispatchToProps = dispatch => ({
  getAncestors: clientId => dispatch(fetchClientAncestors(clientId)),
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Breadcrumbs)
);
